const filters = document.querySelector('.filters');
const priceRangeMax = filters.querySelector('.price-range-max');
const filtersContainer = filters.closest('.filters-container');

function filtersLoadUrl(url, noPushState) {
  if (!noPushState) {
    let fullUrl = url;
    if (fullUrl.slice(0, 1) === '/') {
      fullUrl = `${window.location.protocol}//${window.location.host}${fullUrl}`;
    }
    window.history.pushState({ path: fullUrl }, '', fullUrl);
  }
  
  let fetchUrl = url;
  const sectionId = filters.dataset.filterSectionId;
  if (sectionId) {
    fetchUrl = `${url}${url.indexOf('?') >= 0 ? '&' : '?'}section_id=${sectionId}`;
  }
  if(!filtersContainer) return;

  const filtersCount = filtersContainer.querySelector('.filters-count');
  const ajaxProduct = filtersContainer.querySelector('.ajax-product');
  const paginateContainer = filtersContainer.querySelector('.paginate-container');
  
  if (ajaxProduct) {
    ajaxProduct.classList.add('ccloading');
  }
  
  fetch(fetchUrl)
    .then(response => response.text())
    .then(data => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');
      
      const getFiltersCount = doc.querySelector('.filters-count');
      const getAjaxProduct = doc.querySelector('.ajax-product');
      const getAjaxPaginate = doc.querySelector('.paginate-container');
      
      if (filtersCount && getFiltersCount) {
        filtersCount.innerHTML = getFiltersCount.innerHTML;
      }
      
      if (ajaxProduct && getAjaxProduct) {
        ajaxProduct.innerHTML = getAjaxProduct.innerHTML;
      }
      
      if (paginateContainer && getAjaxPaginate) {
        paginateContainer.innerHTML = getAjaxPaginate.innerHTML;
      }
      
      const filterGroups = doc.querySelectorAll('.filter-group');
      filterGroups.forEach(function(el) {
        const groupName = el.dataset.groupName;
        if (groupName) {
          if (groupName === 'filter-group-applied') {
            const targetElement = document.querySelector(`.${groupName}`);
            if (targetElement) {
              targetElement.innerHTML = el.innerHTML;
            }
          } else {
            const targetElement = document.querySelector(`.${groupName} .disclosure-panel`);
            const sourceElement = el.querySelector('.disclosure-panel');
            if (targetElement && sourceElement) {
              targetElement.innerHTML = sourceElement.innerHTML;
            }
          }
        }
      });
    })
    .catch(error => {
      console.error('Filter loading error:', error);
    })
    .finally(() => {
      if (ajaxProduct) {
        ajaxProduct.classList.remove('ccloading');
      }
    });
}
function filtersForm(e) {
  if (e.type === 'submit') {
    e.preventDefault();
  }
  
  const autoHideUnavailable = filters.dataset.autoHideUnavailable === 'true';
  if (autoHideUnavailable) {
    const filterAvailability = filters.querySelector('[name="filter.v.availability"]');
    if (filterAvailability) {
      filterAvailability.checked = true;
    }
  }
  
  let queryParam = [];
  const inputs = filters.querySelectorAll('input, select');
  
  inputs.forEach(function(el) {
    const elType = el.getAttribute('type');
    const elName = el.getAttribute('name');
    const elValue = el.value;
    
    if (((elType !== 'checkbox' && elType !== 'radio') || el.checked) && elValue !== '' && elName) {
      queryParam.push([elName, encodeURIComponent(elValue)]);
    }
  });
  
  let newUrl = window.location.pathname;
  queryParam.forEach(function(val) {
    newUrl += `&${val[0]}=${val[1]}`;
  });
  
  newUrl = newUrl.replace('&', '?');
  filtersLoadUrl(newUrl);
}
function filtersPopState() {
  filtersLoadUrl(document.location.href, true);
}

const debouncedFilters = debounce(filtersForm, 500);
function handleFilterChange(e) {
  if (e.type === 'submit') {
    e.preventDefault();
  }
  debouncedFilters(e);
}

filters.addEventListener('change', handleFilterChange);
filters.addEventListener('submit', handleFilterChange);
filters.addEventListener('input', function(e) {
  if (e.target.classList.contains('price-range')) {
    e.preventDefault();
    let rangeVal = e.target.value;
    if (priceRangeMax) {
      priceRangeMax.value = rangeVal;
    }
  }
});

window.addEventListener('popstate', filtersPopState);
document.addEventListener('click', function(e) {
  const filterRemove = e.target.closest('.filters .filter-remove');
  const filterBtn = e.target.closest('.filterbtn');
  
  if (filterRemove) {
    e.preventDefault();
    filtersLoadUrl(filterRemove.getAttribute('href'));
  } else if (filterBtn) {
    e.preventDefault();
    if (window.innerWidth >= 768) {
      if (filters.classList.contains('desktop-show')) {
        filters.classList.remove('desktop-show');
        SimpleOffcanvas.hide(filters,false);
      } else {
        SimpleOffcanvas.toggle(filters,false);
      }
    } else {
      SimpleOffcanvas.toggle(filters,false);
    }
    filterBtn.classList.toggle('open');
  }
});